import React from 'react';
import { CompanyNameInput } from '../../components/companyNameInput';
import { formatText, HtmlText } from 'core/i18n';
import BlockWrapper from 'components/blockWrapper/blockWrapper';
import { Cnae } from 'components/professionTypes/cnae';
import { recordEventCustomOnly } from 'utilities/uTagging';
import { FiocTgssConsent } from '../../components/FiocTgssConsent';
import MessageBox from 'components/commons/MessageBox/MessageBox';

export const ReducedQuestions = ({
    disabled,
    formActions,
    onHandleSave,
    shouldRenderTgssQuestion,
    showCompanyNameWarning,
    setShowCompanyNameWarning,
    userProfile,
    userProfileForm,
    ...props
}) => {
    const { profession_id, selfEmployed_company } = userProfile;

    return (
        <section className="fioc-account-type">
            <BlockWrapper position={0} visible={true} cancelDefaultFocusBehavior>
                <div className="fioc-account-type__cnae">
                    <Cnae disabled={disabled} formActions={formActions} handleSave={onHandleSave} {...props} />
                </div>
            </BlockWrapper>

            <BlockWrapper position={1} visible={false} firstValue={profession_id || selfEmployed_company}>
                <div className="fioc-account-type__company-name">
                    <CompanyNameInput
                        formActions={formActions}
                        handleOnFocus={() => {
                            setShowCompanyNameWarning(true);
                            recordEventCustomOnly({
                                accionEvento: 'nombre de la empresa',
                                categoriaEvento: 'interaccion en tu actividad',
                            });
                        }}
                        isValidated={() => {
                            setShowCompanyNameWarning(false);
                            onHandleSave('companyName', selfEmployed_company);
                        }}
                        label={formatText('field-tradename')}
                        profileModel="userProfile.selfEmployed_company"
                        userProfileForm={userProfileForm}
                        userProfile={userProfile}
                    />
                </div>
                {showCompanyNameWarning && (
                    <div className="fioc-account-type__messages__company-name">
                        <MessageBox
                            boxColor="yellow"
                            iconColor="warning-yellow"
                            titleText={formatText('field-companyNameWarningTitle')}
                            contentText={HtmlText(formatText('field-companyNameWarningDescription'))}
                        />
                    </div>
                )}
            </BlockWrapper>

            {shouldRenderTgssQuestion && (
                <BlockWrapper position={2} visible={false} firstValue={selfEmployed_company}>
                    <div className="fioc-account-type__tgss-consent">
                        <FiocTgssConsent
                            formActions={formActions}
                            userProfileForm={userProfileForm}
                            userProfile={userProfile}
                        />
                    </div>
                </BlockWrapper>
            )}
        </section>
    );
};
